




























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class ChartCount extends Vue {
  @Prop() private title!: string;
  @Prop() private data!: any;
  @Prop() private intervalTime!: any;
}
